export default __webpack_public_path__ + "static/media/landing_page__1_.acd627ef.jpg";